const resources = {
    via: 'via'
};

module.exports = function getResource(label) {
    return resources[label];
};
